<template>
  <div class="retags-container">
    <div
      class="reetags-player"
      v-if="isItemTypeSticky"
      :data-token="items.token"
      data-reetags-type="sticky"
      style="position: relative; height: 0; max-width: 100%; margin: auto"
    ></div>

    <div class="retags" v-else>
      <div class="retags-container" v-if="items.title && items.description">
        <div class="reetag-title">{{ items.title }}</div>
        <div class="reetag-desc" v-htmlsafe="items.description"></div>
      </div>
      <div
        class="reetags-player"
        :class="items.cssClass"
        :data-reetags-type="items?.type"
      >
        <iframe
          class="reetags__iframe"
          name="player"
          title="reetag"
          :src="iframeUrl"
          frameborder="0"
          allow="autoplay; fullscreen; picture-in-picture; web-share"
          loading="lazy"
        ></iframe>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'reetag',
  data() {
    return {
      iframeUrl: null,
    };
  },
  props: {
    items: {
      type: Object,
      required: true,
      default: null,
    },
  },
  computed: {
    isItemTypeSticky() {
      return this.items.type?.toLowerCase() === 'sticky';
    },
  },
  mounted() {
    this.loadScript();
    this.iframeUrl =
      'https://player.reetags.com/player?token=' + this.items.token;
  },
  methods: {
    loadScript() {
      let scriptEle = document.createElement('script');
      scriptEle.setAttribute('type', 'application/javascript');
      scriptEle.setAttribute('src', this.items.scriptSrc);
      document.head.appendChild(scriptEle);
    },
  },
};
</script>
<style scoped lang="scss" src="./reetag.scss"></style>
